import { useTranslation } from "react-i18next";
import Header from "../components/Header";
import Footer from "../components/Footer";
import FloatingActions from "../components/FloatingActions";
import JoinFSG from "../sections/JoinFSG";
import Gallery from "../sections/Gallery";
import useSeo, { breadcrumbJsonLd, organizationJsonLd } from "../lib/seo";
import { useLang } from "../lib/useLang";

export default function JoinPage() {
  const { t } = useTranslation();
  const lang = useLang();

  useSeo({
    title: t("join.title"),
    description: t("join.lead"),
    path: "/unete",
    lang,
    jsonLd: [
      organizationJsonLd(),
      breadcrumbJsonLd([
        { name: lang === "en" ? "Home" : "Inicio", path: "/" },
        { name: t("join.title"), path: "/unete" },
      ]),
    ],
  });

  return (
    <div className="fsg-app">
      <Header />
      <main className="fsg-main" id="contenido">
        <JoinFSG />
        <Gallery />
      </main>
      <Footer />
      <FloatingActions />
    </div>
  );
}
